module.exports = "https://trybtryb-legacy.web.app/img/star-empty.171bd8b1.svg";